import { render, staticRenderFns } from "./PsAccount.vue?vue&type=template&id=2a745a2c&scoped=true&"
import script from "./PsAccount.vue?vue&type=script&lang=js&"
export * from "./PsAccount.vue?vue&type=script&lang=js&"
import style0 from "./PsAccount.vue?vue&type=style&index=0&id=2a745a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a745a2c",
  null
  
)

export default component.exports